import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem, g as global$1, n as nextTick } from './index.esm-7182addc.js';
import { c as createPopper } from './popper-1604923e.js';
import { d as debounce } from './debounce-9f9e988a.js';

const gravityFilterDropdownCss = ":host{max-width:164px;min-width:96px}.gravity-filter-dropdown{position:relative}.gravity-filter-dropdown__trigger{all:unset}.gravity-filter-dropdown__trigger{align-items:center;border:1px solid rgba(0, 15, 30, 0.2);border-radius:4px;box-sizing:border-box;cursor:pointer;display:flex;height:32px;padding-inline:12px;width:100%}.gravity-filter-dropdown__trigger:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-filter-dropdown__trigger:focus-visible{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-filter-dropdown__trigger-label{flex:1}.gravity-filter-dropdown__counter-badge{margin-inline:6px 4px;visibility:hidden}.gravity-filter-dropdown--has-value .gravity-filter-dropdown__counter-badge{visibility:visible}.gravity-filter-dropdown__trigger-icon{display:none;height:16px;width:16px}.gravity-filter-dropdown:not(.gravity-filter-dropdown--has-value) .gravity-filter-dropdown__trigger-icon{display:flex}.gravity-filter-dropdown--open .gravity-filter-dropdown__trigger-icon{transform:rotate(180deg)}.gravity-filter-dropdown__dropdown{background-color:#FFFFFF;border:1px solid rgba(0, 15, 30, 0.2);border-radius:6px;box-shadow:0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;opacity:0;pointer-events:none;position:fixed;visibility:hidden;z-index:1000}.gravity-filter-dropdown--open .gravity-filter-dropdown__dropdown{opacity:1;pointer-events:auto;transition:opacity 100ms cubic-bezier(0.32, 0, 0.32, 1);visibility:visible}.gravity-filter-dropdown__clear-button{align-items:center;all:unset;background-color:rgba(0, 15, 30, 0.1);border-radius:9999px;cursor:pointer;display:none;height:16px;justify-content:center;width:16px}.gravity-filter-dropdown--has-value .gravity-filter-dropdown__clear-button{display:flex}.gravity-filter-dropdown__clear-button:hover{background-color:rgba(0, 15, 30, 0.2)}.gravity-filter-dropdown__clear-button:focus-visible{outline:#1B6AEE solid 2px;outline-offset:2px}";
const GravityFilterDropdownStyle0 = gravityFilterDropdownCss;

const GravityFilterDropdown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.filterChange = createEvent(this, "filterChange", 7);
        this.searchChange = createEvent(this, "searchChange", 7);
        this.generateClassNames = bem('gravity-filter-dropdown');
        this.clearSelection = (event) => {
            var _a, _b;
            event.stopPropagation();
            this.value = [];
            if (this.searchable && ((_a = this.dropdownInnerElement) === null || _a === void 0 ? void 0 : _a.shadowRoot)) {
                (_b = this.dropdownInnerElement.shadowRoot.querySelector('gravity-search')) === null || _b === void 0 ? void 0 : _b.reset();
            }
            this.filterChange.emit({
                filterId: this.id,
                value: [],
            });
            this.closeDropdown();
        };
        this.handleTriggerClick = () => {
            this.toggleDropdown();
        };
        this.handleTriggerKeyDown = (event) => {
            if (event.target instanceof HTMLElement &&
                event.target.classList.contains(this.generateClassNames('clear-button'))) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    this.clearSelection(event);
                }
                return;
            }
            if ((event.key === 'Enter' || event.key === ' ') && !this.isOpen) {
                event.preventDefault();
                this.toggleDropdown();
            }
        };
        this.handleOptionSelected = (event) => {
            this.value = event.detail;
            this.filterChange.emit({
                filterId: this.id,
                value: event.detail,
            });
        };
        this.handleSearchChange = (event) => {
            this.searchChange.emit(event.detail);
        };
        this.boundaryElement = undefined;
        this.id = undefined;
        this.label = undefined;
        this.options = undefined;
        this.queryType = undefined;
        this.searchable = false;
        this.searchBusy = false;
        this.searchPlaceholder = undefined;
        this.value = [];
        this.width = '300px';
        this.isOpen = false;
    }
    handleWindowClick(event) {
        if (!this.isOpen || this.isClickInside(event)) {
            return;
        }
        this.closeDropdown();
    }
    handleToolbarResize() {
        if (this.isOpen) {
            this.closeDropdown();
        }
    }
    handleDropdownOpen(event) {
        if (event.detail.id !== this.id && this.isOpen) {
            this.closeDropdown();
        }
    }
    isClickInside(event) {
        const path = event.composedPath();
        return path.includes(this.triggerElement) || path.includes(this.dropdownElement);
    }
    closeDropdown() {
        this.isOpen = false;
    }
    openDropdown() {
        this.isOpen = true;
        global$1.window.dispatchEvent(new CustomEvent('gravity-filter-dropdown-open', {
            detail: { id: this.id },
        }));
    }
    async toggleDropdown() {
        var _a;
        if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.length) || !this.popperInstance) {
            return;
        }
        if (this.isOpen) {
            this.closeDropdown();
        }
        else {
            this.openDropdown();
            await this.popperInstance.update();
        }
    }
    async initializePopper() {
        await nextTick();
        if (!this.triggerElement || !this.dropdownElement) {
            return;
        }
        this.popperInstance = createPopper(this.triggerElement, this.dropdownElement, {
            strategy: 'fixed',
            placement: 'bottom-start',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this.boundaryElement || 'clippingParents',
                        padding: 8,
                        mainAxis: true,
                        altAxis: false,
                        tether: true,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        boundary: this.boundaryElement || 'clippingParents',
                        fallbackPlacements: ['bottom-end', 'top-start', 'top-end'],
                    },
                },
            ],
        });
    }
    get hasValue() {
        return !!(this.value && this.value.length > 0);
    }
    async componentDidLoad() {
        await this.initializePopper();
    }
    disconnectedCallback() {
        var _a;
        (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    render() {
        return (h("div", { key: '85ca8e1fc957159b5c008ca8ac804a5b69b63be4', class: this.generateClassNames({
                'has-value': this.hasValue,
                'open': this.isOpen,
            }) }, h("button", { key: 'de81ad984cf31c004f4e3a0cb38ec79e73955fb7', class: this.generateClassNames('trigger'), onClick: this.handleTriggerClick, onKeyDown: this.handleTriggerKeyDown, ref: (el) => (this.triggerElement = el), type: "button" }, h("gravity-text", { key: 'f10f7c64451256e70cedf781594c1eab1e7cf132', clamp: 1, class: this.generateClassNames('trigger-label'), color: this.hasValue ? 'dark' : 'dark-subtle', size: "xx-small" }, this.label), h("gravity-counter-badge", { key: 'a296aec0fe227e7c81027f399e0a451abfa2f584', class: this.generateClassNames('counter-badge') }, this.value.length), h("button", { key: 'a520a831b8097d96096622965302963313698170', class: this.generateClassNames('clear-button'), onClick: this.clearSelection }, h("gravity-icon", { key: '4dd11cbf9b15044010ee22eaebefddd991c951a6', color: "dark", name: "close", size: "tiny" })), h("gravity-icon", { key: 'fba7e32a1173ee44f14e70e19efdb04fef75916b', class: this.generateClassNames('trigger-icon'), color: "dark-subtle", name: "arrow-down", size: "tiny" })), h("div", { key: '330fc0ac622dc77f066c683f468849ed975c7233', class: this.generateClassNames('dropdown'), ref: (el) => (this.dropdownElement = el) }, h("gravity-dropdown-inner", { key: '3e9aa15e61144cc310ffed6ea29544fba4e116aa', dropdown: this.hostElement, isRoot: true, keyboardNavigation: this.isOpen, maxHeight: 274, onDropdownOptionSelected: this.handleOptionSelected, onHide: () => this.closeDropdown(), onSearchChange: this.handleSearchChange, options: this.options, queryType: this.searchable ? this.queryType || 'filter' : false, ref: (el) => (this.dropdownInnerElement = el), searchBusy: this.searchBusy, searchPlaceholder: this.searchPlaceholder, selected: this.value, selectionBehavior: "multi", size: "small", triggerElement: this.triggerElement, visible: this.isOpen, width: this.width }))));
    }
    get hostElement() { return getElement(this); }
};
GravityFilterDropdown.style = GravityFilterDropdownStyle0;

const gravitySortingMenuCss = ".gravity-sorting-menu{position:relative}.gravity-sorting-menu__toggle{all:unset}.gravity-sorting-menu__toggle{align-items:center;box-sizing:border-box;cursor:pointer;display:none;gap:3px;height:32px;justify-content:center}.gravity-sorting-menu__toggle:focus-visible{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-sorting-menu__toggle--desktop{border-radius:2px;display:flex;padding-inline:8px}.gravity-sorting-menu--is-mobile .gravity-sorting-menu__toggle--desktop{display:none}.gravity-sorting-menu__toggle--mobile{border:1px solid rgba(0, 15, 30, 0.2);border-radius:9999px;display:none;width:32px}.gravity-sorting-menu__toggle--mobile:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-sorting-menu--is-mobile .gravity-sorting-menu__toggle--mobile{display:flex}.gravity-sorting-menu__dropdown{background-color:#FFFFFF;border:1px solid rgba(0, 15, 30, 0.2);border-radius:6px;box-shadow:0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;opacity:0;pointer-events:none;position:fixed;visibility:hidden;z-index:1000}.gravity-sorting-menu--open .gravity-sorting-menu__dropdown{opacity:1;pointer-events:auto;transition:opacity 100ms cubic-bezier(0.32, 0, 0.32, 1);visibility:visible}.gravity-sorting-menu__dropdown-inner{max-width:240px;min-width:120px}";
const GravitySortingMenuStyle0 = gravitySortingMenuCss;

const GravitySortingMenu = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.sortingChanged = createEvent(this, "sortingChanged", 1);
        this.generateClassNames = bem('gravity-sorting-menu');
        this.handleOptionClicked = (event) => {
            var _a;
            const selectedId = Array.isArray(event.detail) ? event.detail[0] : event.detail;
            if ((_a = this.sorting) === null || _a === void 0 ? void 0 : _a.options) {
                this.sorting.options = this.sorting.options.map((option) => (Object.assign(Object.assign({}, option), { selected: option.id === selectedId })));
            }
            this.sortingChanged.emit(selectedId);
            this.isOpen = false;
        };
        this.isMobile = false;
        this.sorting = undefined;
        this.isHovered = false;
        this.isOpen = false;
    }
    handleWindowClick(event) {
        if (!this.isOpen || this.isClickInside(event)) {
            return;
        }
        this.toggleDropdown();
    }
    handleToolbarResize() {
        if (this.isOpen) {
            this.isOpen = false;
        }
    }
    isClickInside(event) {
        const path = event.composedPath();
        return path.includes(this.triggerElement) || path.includes(this.dropdownElement);
    }
    async toggleDropdown() {
        var _a, _b, _c;
        if (!((_b = (_a = this.sorting) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.length)) {
            return;
        }
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            await ((_c = this.popperInstance) === null || _c === void 0 ? void 0 : _c.update());
        }
    }
    getSelectedValue() {
        var _a, _b;
        const selectedOption = (_b = (_a = this.sorting) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find((option) => option.selected);
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) ? [selectedOption.id] : [];
    }
    async initializePopper() {
        await nextTick();
        if (!this.triggerElement || !this.dropdownElement) {
            return;
        }
        this.popperInstance = createPopper(this.triggerElement, this.dropdownElement, {
            strategy: 'fixed',
            placement: 'bottom-end',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 8,
                        altAxis: true,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-end', 'bottom-start', 'top-start'],
                    },
                },
            ],
        });
    }
    async componentDidLoad() {
        await this.initializePopper();
    }
    disconnectedCallback() {
        var _a;
        (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    render() {
        var _a;
        return (h("div", { key: '66c2b540df9e7fed3169b878f0e84a4479869e89', class: this.generateClassNames({ 'open': this.isOpen, 'is-mobile': this.isMobile }) }, h("button", { key: '7cfa5dec08d1fe7897e0b4d5eec8f13f2a4c93ff', class: this.generateClassNames('toggle', {
                desktop: !this.isMobile,
                mobile: this.isMobile,
            }), onClick: () => this.toggleDropdown(), onMouseEnter: () => (this.isHovered = true), onMouseLeave: () => (this.isHovered = false), ref: (el) => (this.triggerElement = el), "aria-expanded": this.isOpen, "aria-haspopup": "true" }, h("gravity-icon", { key: '9d0e03800c9273b2bd2c0f47bd7beb63f98df743', name: "arrows-down-up", color: this.isHovered && !this.isMobile ? 'primary' : 'dark-subtle', size: "xxx-small" }), !this.isMobile && (h("gravity-text", { key: '175dfa14aa20f22d91cbf6c59c789653a33be5a9', class: this.generateClassNames('toggle-text'), color: this.isHovered ? 'primary' : 'dark', weight: "medium", size: "xx-small" }, "Sorting"))), h("div", { key: '633f2e3ef52fbb270e53d6f99efef032d7c771c3', class: this.generateClassNames('dropdown'), ref: (el) => (this.dropdownElement = el), role: "menu" }, h("gravity-dropdown-inner", { key: '058510620c2ca4c83b163eebc77c82533ab36fab', class: this.generateClassNames('dropdown-inner'), dropdown: this.hostElement, isRoot: true, keyboardNavigation: this.isOpen, maxHeight: 274, onDropdownOptionClicked: this.handleOptionClicked, onHide: () => (this.isOpen = false), options: (_a = this.sorting) === null || _a === void 0 ? void 0 : _a.options, selected: this.getSelectedValue(), selectionBehavior: "single", size: "small", triggerElement: this.triggerElement, visible: this.isOpen, width: "auto" }))));
    }
    get hostElement() { return getElement(this); }
};
GravitySortingMenu.style = GravitySortingMenuStyle0;

const gravityToolbarActionsCss = ":host{display:block}.gravity-toolbar-actions{display:flex;gap:4px}.gravity-toolbar-actions__secondary-list,.gravity-toolbar-actions__primary-list{align-self:start;display:flex;flex:1;gap:4px;height:55px;justify-content:end;list-style:none;margin:0;padding:0}.gravity-toolbar-actions__secondary-list{flex-wrap:wrap;overflow-y:clip}.gravity-toolbar-actions__primary-list{max-width:fit-content}.gravity-toolbar-actions__primary-list:empty{display:none}.gravity-toolbar-actions__action{align-items:center;animation:fade 0.5s ease;display:flex;height:100%;max-width:100%}.gravity-toolbar-actions__action--hidden{display:none}.gravity-toolbar-actions__action-button{box-sizing:border-box;cursor:pointer;flex-shrink:0;max-width:100%}@keyframes fade{0%{opacity:0}100%{opacity:1}}";
const GravityToolbarActionsStyle0 = gravityToolbarActionsCss;

const GravityToolbarActions = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.actionClicked = createEvent(this, "actionClicked", 1);
        this.actionListRef = null;
        this.generateClassNames = bem('gravity-toolbar-actions');
        this.overflowTriggerRef = null;
        this.actionClickedHandler = (event, actionId) => {
            var _a;
            if (event.target instanceof HTMLAnchorElement) {
                event.preventDefault();
            }
            const action = (_a = this.actions) === null || _a === void 0 ? void 0 : _a.find((action) => action.id === actionId);
            this.actionClicked.emit(actionId);
            if (action === null || action === void 0 ? void 0 : action.href) {
                global$1.window.open(action.href, action.target || '_self');
            }
        };
        this.handleIntersectionChange = (entries) => {
            entries.forEach((entry) => {
                var _a, _b;
                const target = entry.target;
                const firstChild = (_b = (_a = target.firstElementChild) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.firstElementChild;
                if (firstChild) {
                    firstChild.setAttribute('tabIndex', entry.isIntersecting ? '0' : '-1');
                }
            });
        };
        this.actions = undefined;
        this.isMobile = undefined;
        this.actionsCutoff = 0;
        this.overflowTriggerHidden = true;
        this.primaryActions = [];
        this.secondaryActions = [];
    }
    async handleMobileChange() {
        if (!this.isMobile) {
            await this.partitionActions();
        }
        this.actionsCutoff = 0;
    }
    async partitionActions() {
        if (!this.actions || this.actions.length < 1)
            return;
        this.filterActions();
        this.updateActionReferences();
        this.setInitialActionOrder();
        await nextTick();
        this.updateActionVisibilityAndOrder();
        this.observeActionVisibility();
    }
    mapActionsToDropdownOptions(actions) {
        return actions
            .filter((action) => action.type !== 'primary')
            .map(({ id, label, iconName, danger }) => ({
            id,
            label,
            prefix: iconName && `<gravity-icon name=${iconName} size="tiny"></gravity-icon>`,
            danger,
        }));
    }
    filterActions() {
        var _a, _b;
        this.primaryActions = ((_a = this.actions) === null || _a === void 0 ? void 0 : _a.filter((action) => action.type === 'primary')) || [];
        this.secondaryActions = ((_b = this.actions) === null || _b === void 0 ? void 0 : _b.filter((action) => action.type !== 'primary')) || [];
    }
    updateActionReferences() {
        const shadowRoot = this.hostElement.shadowRoot;
        this.actionListRef = shadowRoot.querySelector('.gravity-toolbar-actions__secondary-list');
        this.actionsRef = shadowRoot.querySelectorAll('.gravity-toolbar-actions__action:not(.gravity-toolbar-actions__action--overflow):not(.gravity-toolbar-actions__action--primary)');
        this.overflowTriggerRef = shadowRoot.querySelector('.gravity-toolbar-actions__action--overflow');
    }
    setInitialActionOrder() {
        var _a;
        (_a = this.actionsRef) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            item.style.order = item.dataset.order || '';
        });
    }
    checkIfAllActionsFit() {
        if (!this.overflowTriggerRef || !this.actionListRef)
            return false;
        const actionListOffsetTop = this.actionListRef.offsetTop;
        const allVisible = Array.from(this.actionsRef).every((item) => item.offsetTop === actionListOffsetTop);
        this.overflowTriggerHidden = allVisible;
        return allVisible;
    }
    updateActionVisibilityAndOrder() {
        if (this.isMobile && this.overflowTriggerRef) {
            this.actionsCutoff = 0;
            this.overflowTriggerHidden = false;
            return;
        }
        if (!this.overflowTriggerRef || !this.actionListRef)
            return;
        if (this.checkIfAllActionsFit())
            return;
        this.overflowTriggerRef.style.order = '-1';
        const visibleActions = this.getVisibleActions();
        this.actionsCutoff = visibleActions.length;
        const highestOrder = this.getHighestOrderAmongVisibleActions(visibleActions);
        this.overflowTriggerHidden = this.shouldHideOverflowTrigger(visibleActions);
        this.overflowTriggerRef.style.order = highestOrder.toString();
    }
    getVisibleActions() {
        if (!this.actionListRef)
            return [];
        const actionListOffsetTop = this.actionListRef.offsetTop;
        return Array.from(this.actionsRef).filter((action) => action.offsetTop === actionListOffsetTop);
    }
    getHighestOrderAmongVisibleActions(visibleItems) {
        return visibleItems.reduce((maxOrder, item) => Math.max(maxOrder, parseInt(item.dataset.order || '', 10)), -1);
    }
    shouldHideOverflowTrigger(visibleItems) {
        var _a;
        return ((_a = visibleItems[visibleItems.length - 1]) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === this.overflowTriggerRef;
    }
    observeActionVisibility() {
        var _a;
        if (!this.actionListRef || !((_a = this.actionsRef) === null || _a === void 0 ? void 0 : _a.length))
            return;
        if (this.actionListIntersectionObserver) {
            this.actionListIntersectionObserver.disconnect();
        }
        this.actionListIntersectionObserver = new IntersectionObserver(this.handleIntersectionChange, {
            root: this.actionListRef,
        });
        Array.from(this.actionsRef).forEach((item) => {
            var _a;
            (_a = this.actionListIntersectionObserver) === null || _a === void 0 ? void 0 : _a.observe(item);
        });
    }
    setupResizeObserver() {
        if (!this.actionListRef)
            return;
        this.actionListResizeObserver = new ResizeObserver(debounce(async () => {
            var _a;
            if (((_a = this.secondaryActions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                await this.partitionActions();
            }
        }, 20));
        this.actionListResizeObserver.observe(this.actionListRef);
    }
    setupIntersectionObserver() {
        var _a;
        if (!this.actionListRef || !((_a = this.actionsRef) === null || _a === void 0 ? void 0 : _a.length))
            return;
        this.actionListIntersectionObserver = new IntersectionObserver(this.handleIntersectionChange, {
            root: this.actionListRef,
        });
        Array.from(this.actionsRef).forEach((item) => {
            var _a;
            (_a = this.actionListIntersectionObserver) === null || _a === void 0 ? void 0 : _a.observe(item);
        });
    }
    cleanupObservers() {
        var _a, _b;
        (_a = this.actionListResizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.actionListIntersectionObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
    renderAction(action, hasDataOrder, index) {
        return (h("li", { class: this.generateClassNames('action', { primary: action.type === 'primary' }), key: action.id, "data-order": hasDataOrder ? ++index : undefined, "data-type": action.type }, h("gravity-button", { busy: action.busy, class: this.generateClassNames('action-button', { 'icon-only': action.iconOnly }), iconName: action.iconName, mode: "dark", onClick: (event) => this.actionClickedHandler(event, action.id), size: "small", type: action.type, danger: action.danger }, !action.iconOnly && action.label)));
    }
    renderOverflowMenu() {
        return (h("li", { class: this.generateClassNames('action', { overflow: true, hidden: this.overflowTriggerHidden }), ref: (el) => (this.overflowTriggerRef = el), "data-type": "overflow" }, h("gravity-button", { class: this.generateClassNames('actions-overflow-button'), id: "actions-overflow-trigger", mode: "dark", size: "small", type: "secondary" }, h("gravity-icon", { color: "dark", name: "dots", size: "xxx-small", slot: "icon" })), this.actionsCutoff > -1 && (h("internal-gravity-navigation-dropdown", { for: "actions-overflow-trigger", onDropdownOptionClicked: (event) => this.actionClickedHandler(event, event.detail.id), options: this.mapActionsToDropdownOptions(this.secondaryActions.slice(this.actionsCutoff)), offset: "small" }))));
    }
    async componentWillLoad() {
        await this.partitionActions();
    }
    componentDidLoad() {
        this.updateActionReferences();
        this.setupResizeObserver();
        this.setupIntersectionObserver();
    }
    disconnectedCallback() {
        this.cleanupObservers();
    }
    render() {
        return (h("div", { key: '2662ded81a038ef476d535b7405fc361f2289a00', class: this.generateClassNames() }, h("ul", { key: '1fb22440004151568728db2e8fe0fd89fefcca45', class: this.generateClassNames('secondary-list'), ref: (el) => (this.actionListRef = el) }, !this.isMobile && this.secondaryActions.map((action, index) => this.renderAction(action, true, index)), this.renderOverflowMenu()), this.primaryActions.length > 0 && (h("ul", { key: '85e4bb819eb425983fe8076ac3d772921931e37c', class: this.generateClassNames('primary-list') }, this.primaryActions.map((action, index) => this.renderAction(action, false, index))))));
    }
    get hostElement() { return getElement(this); }
    static get watchers() { return {
        "isMobile": ["handleMobileChange"],
        "actions": ["partitionActions"]
    }; }
};
GravityToolbarActions.style = GravityToolbarActionsStyle0;

export { GravityFilterDropdown as gravity_filter_dropdown, GravitySortingMenu as gravity_sorting_menu, GravityToolbarActions as gravity_toolbar_actions };

//# sourceMappingURL=gravity-filter-dropdown_3.entry.js.map